/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含问题的JSON对象
 */
export type PostAnswerbookAskRequest = { question: string };

export const PostAnswerbookAskRequest$zodSchema: z.ZodType<
  PostAnswerbookAskRequest
> = z.object({
  question: z.string(),
}).describe("包含问题的JSON对象");

/**
 * 服务器内部错误。
 */
export type PostAnswerbookAskInternalServerErrorResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
};

export const PostAnswerbookAskInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostAnswerbookAskInternalServerErrorResponseBody> = z.object({
    code: z.int().optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误。");

/**
 * 请求参数无效。
 */
export type PostAnswerbookAskBadRequestResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
};

export const PostAnswerbookAskBadRequestResponseBody$zodSchema: z.ZodType<
  PostAnswerbookAskBadRequestResponseBody
> = z.object({
  code: z.int().optional(),
  message: z.string().optional(),
}).describe("请求参数无效。");

/**
 * 成功获取答案。
 */
export type PostAnswerbookAskResponseBody = {
  question?: string | undefined;
  answer?: string | undefined;
};

export const PostAnswerbookAskResponseBody$zodSchema: z.ZodType<
  PostAnswerbookAskResponseBody
> = z.object({
  answer: z.string().optional(),
  question: z.string().optional(),
}).describe("成功获取答案。");

export type PostAnswerbookAskResponse =
  | PostAnswerbookAskResponseBody
  | PostAnswerbookAskBadRequestResponseBody
  | PostAnswerbookAskInternalServerErrorResponseBody;

export const PostAnswerbookAskResponse$zodSchema: z.ZodType<
  PostAnswerbookAskResponse
> = z.union([
  z.lazy(() => PostAnswerbookAskResponseBody$zodSchema),
  z.lazy(() => PostAnswerbookAskBadRequestResponseBody$zodSchema),
  z.lazy(() => PostAnswerbookAskInternalServerErrorResponseBody$zodSchema),
]);
